/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Weighing_Is_ApprovedInputs */

const vi_weighing_is_approved = /** @type {(inputs: Weighing_Is_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã duyệt`)
};

/**

* @param {Weighing_Is_ApprovedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const weighing_is_approved = /** @type {((inputs?: Weighing_Is_ApprovedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Weighing_Is_ApprovedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_weighing_is_approved(inputs)
});